import { CostAssumption } from "in_queue/types/scenarioType";
import { isEqual } from "lodash";
import { BulkScenarioSettings } from "./bulkScenarioDrafts";

const batchSubject = (count: number, total: number): string => {
    if (count < total) {
        return String(count);
    }
    return total === 1 ? "It" : "All of them";
};

const runSummary = (total: number, runCount: number): string => {
    const draftCount = total - runCount;
    if (draftCount === 0) {
        return `${batchSubject(runCount, total)} will run now.`;
    }
    if (runCount === 0) {
        return `${batchSubject(draftCount, total)} will be saved as ${
            total === 1 ? "a draft" : "drafts"
        }.`;
    }
    return `${runCount} will run now and ${draftCount} will be saved as drafts.`;
};

const usesSummary = (count: number, total: number, setting: string): string =>
    `${batchSubject(count, total)} ${count === 1 ? "uses" : "use"} ${setting}.`;

/** One short sentence per fact about the batch, leaving out settings no scenario uses. */
export const bulkScenarioCreateSummary = (
    drafts: ReadonlyArray<BulkScenarioSettings>,
    defaultCostAssumptions: CostAssumption
): ReadonlyArray<string> => {
    const total = drafts.length;
    const runCount = drafts.filter((draft) => draft.runOnSubmit).length;
    const customUpgradeCount = drafts.filter(
        (draft) => draft.customUpgradeId !== null
    ).length;
    const otherCostCount = drafts.filter(
        (draft) => !isEqual(draft.costAssumptions, defaultCostAssumptions)
    ).length;

    return [
        runSummary(total, runCount),
        ...(customUpgradeCount > 0
            ? [usesSummary(customUpgradeCount, total, "a custom upgrade")]
            : []),
        ...(otherCostCount > 0
            ? [
                  usesSummary(
                      otherCostCount,
                      total,
                      "cost assumptions other than the default"
                  )
              ]
            : [])
    ];
};
